<template>
    <comp-9-prep-adherence :section="9" :page="28" :nextDisabled="nextDisabled" :next="nextScreen">
        <p>
            Your response to this screening question shows that you may have a high level of protection from getting HIV. In order to keep this up, it’s
            important to try to take PrEP every day, and at the very minimum continue to take PrEP 4 or more days a week. Keep up the good work!
        </p>
        <p>
            Are you interested in support to take your medication every day?
        </p>
        <v-radio-group v-model="prepAdherenceSupportSelection" column>
            <v-radio
                v-for="adherenceSupport in prepAdherenceSupports"
                :key="adherenceSupport.id"
                :label="adherenceSupport.text"
                :value="adherenceSupport"
            ></v-radio>
        </v-radio-group>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepAdherenceSupportSelection: null
        };
    },
    computed: {
        prepAdherenceSupport() {
            let selectedPrepAdherenceSupport = find(this.prepAdherenceSupports, 'selected');

            if (selectedPrepAdherenceSupport) {
                return selectedPrepAdherenceSupport;
            } else return null;
        },
        prepAdherenceSupports: sync('section9/prepAdherenceSupport'),
        nextScreen() {
            if (this.prepAdherenceSupportSelection) {
                return `/page/9/${this.prepAdherenceSupportSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.prepAdherenceSupportSelection;
        }
    },
    watch: {
        prepAdherenceSupportSelection(newPrepAdherenceSupportSelection) {
            forEach(this.prepAdherenceSupports, o => {
                if (o.id === newPrepAdherenceSupportSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.prepAdherenceSupportSelection = this.prepAdherenceSupport;
    }
};
</script>
